import "@fortawesome/fontawesome-pro/css/all.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
  theme: {
    primary: "#493cb7"
  },
  options: {
    customProperties: true
  }
});
